module.exports = __webpack_public_path__ + "assets/img/Pdd.31383271.png";